// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.center-container[data-v-896ab43a] {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n", ""]);
// Exports
module.exports = exports;
